import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';

export default function PortailEnseignant() {
  const [tab, setTab] = useState('profil');
  const [teacher, setTeacher] = useState(null);
  const [stats, setStats] = useState({ eleves: 0, classes: 0, matieres: 0, presences: 0 });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Charger le profil enseignant depuis staff
    api.get('/staff').then((staff) => {
      const me = (staff || []).find((s) => s.email === user.email || s.firstName === user.firstName);
      if (me) setTeacher(me);
    }).catch(() => {});
    Promise.all([api.get('/students'), api.get('/catalog/classes')]).then(([students, classes]) => {
      setStats({ eleves: (students || []).length, classes: (classes || []).length, matieres: 1, presences: 45 });
    }).catch(() => {});
  }, []);

  const initials = teacher ? `${(teacher.firstName || '?')[0]}${(teacher.lastName || '')[0] || ''}`.toUpperCase() : '?';

  return (
    <>
      {/* En-tête profil */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ padding: '20px 24px' }}>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16 }}>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--primary)', color: '#fff', display: 'grid', placeItems: 'center', fontSize: '1.4rem', fontWeight: 700 }}>{initials}</div>
            <div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>{teacher ? `${teacher.firstName} ${teacher.lastName}` : '—'}</h1>
                <span className="badge green">● Actif</span>
              </div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>
                📋 Matricule : {teacher?.matricule || '—'}
                {teacher?.subject1 && <span style={{ marginLeft: 12 }}>🎓 Spécialité : {teacher.subject1}</span>}
              </div>
            </div>
          </div>

          <div className="kpi-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', margin: 0 }}>
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)' }}>{stats.eleves}</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>Étudiants uniques</div>
            </div>
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)' }}>{stats.classes}</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>Classes assignées</div>
            </div>
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)' }}>{stats.matieres}</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>Matières enseignées</div>
            </div>
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)' }}>{stats.presences}</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>Présences saisies</div>
            </div>
          </div>
        </div>
      </div>

      {/* Onglets */}
      <div className="tabs">
        {[['profil', 'Profil'], ['classes', 'Classes & Matières'], ['notes', 'Saisie des Notes'], ['edt', 'Emploi du Temps'], ['presences', 'Présences saisies'], ['conges', 'Congés & Absences']].map(([v, l]) => (
          <button key={v} className={`tab ${tab === v ? 'active' : ''}`} onClick={() => setTab(v)}>{l}</button>
        ))}
      </div>

      {tab === 'profil'    && <ProfilEnseignant teacher={teacher} />}
      {tab === 'classes'   && <MesClasses />}
      {tab === 'notes'     && <SaisieNotesEnseignant />}
      {tab === 'edt'       && <EdtEnseignant />}
      {tab === 'presences' && <PresencesEnseignant />}
      {tab === 'conges'    && <CongesEnseignant staffId={teacher?.id} />}
    </>
  );
}

function ProfilEnseignant({ teacher: t }) {
  if (!t) return <div className="card"><div className="empty">Profil non trouvé. Complétez votre fiche dans Personnel.</div></div>;
  const R = (l, v) => v ? <div className="view-row"><span className="view-label">{l}</span><span className="view-value">{v}</span></div> : null;
  return (
    <div className="card">
      <div className="card-body" style={{ padding: 16 }}>
        <div className="fieldset-title">Informations personnelles</div>
        <div className="view-grid">
          {R('Nom complet', t.firstName && `${t.firstName} ${t.lastName}`)}
          {R('Email', t.email)}
          {R('Téléphone', t.phone)}
          {R('Date de naissance', t.birthDate ? new Date(t.birthDate).toLocaleDateString('fr-FR') : null)}
          {R('Sexe', t.gender === 'M' ? 'Masculin' : 'Féminin')}
          {R('Adresse / Lieu de naissance', t.birthPlace)}
          {R('Date d\'embauche', t.hireDate ? new Date(t.hireDate).toLocaleDateString('fr-FR') : null)}
          {R('Spécialité', t.subject1)}
          {R('Matricule', t.matricule)}
        </div>
        <div className="fieldset-title">Informations complémentaires</div>
        <div className="view-grid">
          {R('Qualification', t.qualification)}
          {R('Diplôme', t.diploma)}
          {R('Années d\'expérience', t.taughtHours ? `${Math.round(t.taughtHours / 200)} an(s)` : null)}
        </div>
      </div>
    </div>
  );
}

function MesClasses() {
  const [sessions, setSessions] = useState([]);
  useEffect(() => {
    api.get('/timetable').then(setSessions).catch(() => {});
  }, []);

  const byClass = {};
  sessions.forEach((s) => {
    const key = s.class?.name || s.classId;
    if (!byClass[key]) byClass[key] = { name: key, subjects: new Set(), sessions: [] };
    byClass[key].subjects.add(s.subject?.name || s.subjectId);
    byClass[key].sessions.push(s);
  });

  return (
    <div className="card">
      <div className="card-head"><h2>Mes Classes & Matières</h2></div>
      <div className="card-body">
        {Object.values(byClass).length === 0 ? <div className="empty">Aucune classe assignée.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Classe</th><th>Matières</th><th className="num">Séances/sem</th></tr></thead>
            <tbody>{Object.values(byClass).map((c, i) => (
              <tr key={i}>
                <td><b>{c.name}</b></td>
                <td>{[...c.subjects].join(', ')}</td>
                <td className="num">{c.sessions.length}</td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}

function SaisieNotesEnseignant() {
  const navigate = useNavigate();
  const [evals, setEvals] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [filters, setFilters] = useState({ classId: '', subjectId: '' });

  useEffect(() => {
    api.get('/evaluations').then(setEvals).catch(() => {});
    api.get('/catalog/classes').then(setClasses).catch(() => {});
    api.get('/catalog/subjects').then(setSubjects).catch(() => {});
  }, []);

  const filtered = evals.filter((e) => {
    if (filters.classId && e.classId !== filters.classId) return false;
    if (filters.subjectId && e.subjectId !== filters.subjectId) return false;
    return true;
  });

  // Grouper par semestre
  const bySemestre = {};
  filtered.forEach((e) => {
    const key = e.period?.name || 'Semestre 1';
    if (!bySemestre[key]) bySemestre[key] = [];
    bySemestre[key].push(e);
  });

  const STATUS_LABEL = { BROUILLON: { l: 'À saisir', cls: 'gold' }, CORRIGE: { l: 'Corrigé', cls: 'blue' }, PUBLIE: { l: 'Publié', cls: 'green' }, VALIDE: { l: 'Validé', cls: 'green' }, CLOTURE: { l: 'Clôturé', cls: 'gray' } };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
        <div>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 600 }}>Saisie des Notes</h2>
          <p style={{ fontSize: 12, color: 'var(--muted)' }}>Ouvrez une grille par classe / matière / semestre pour saisir les notes.</p>
        </div>
        <button className="btn-ghost btn-sm" onClick={() => navigate('/evaluations')}>Résultats & Statistiques →</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 10, marginBottom: 16, alignItems: 'flex-end' }}>
        <div className="field" style={{ margin: 0 }}><label>Classe</label>
          <select value={filters.classId} onChange={(e) => setFilters({ ...filters, classId: e.target.value })}>
            <option value="">Toutes les classes</option>
            {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="field" style={{ margin: 0 }}><label>Matière</label>
          <select value={filters.subjectId} onChange={(e) => setFilters({ ...filters, subjectId: e.target.value })}>
            <option value="">Toutes les matières</option>
            {subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
        <button className="btn btn-sm" style={{ height: 38 }} onClick={() => navigate('/evaluations/new')}>+ Nouvelle évaluation</button>
      </div>

      {Object.entries(bySemestre).map(([sem, evs]) => (
        <div key={sem} className="card" style={{ marginBottom: 12 }}>
          <div className="card-head">
            <h3 style={{ fontSize: 14 }}>{sem} — {evs.length} matière(s)</h3>
          </div>
          <div className="card-body" style={{ padding: 0 }}>
            {evs.map((ev) => {
              const results = ev.results || [];
              const total = results.length;
              const remplis = results.filter((r) => r.totalObtained != null).length;
              const pct = total > 0 ? Math.round(remplis / total * 100) : 0;
              const { l, cls } = STATUS_LABEL[ev.status] || { l: ev.status, cls: 'gray' };
              return (
                <div key={ev.id} style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--line)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                        <span style={{ fontSize: 11, background: 'var(--primary-soft)', color: 'var(--primary)', padding: '2px 6px', borderRadius: 4 }}>
                          {ev.academicYear?.name || '2025-2026'} · S1
                        </span>
                        <span className={`badge ${cls}`}>{l}</span>
                      </div>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{ev.class?.name || '—'} — {ev.subject?.name || '—'}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                        {ev.title} · Coeff. {ev.coefficient || 1}
                        {ev.teacher && <span style={{ marginLeft: 8 }}>{ev.teacher.lastName} {ev.teacher.firstName}</span>}
                      </div>

                      {/* Avancement */}
                      <div style={{ marginTop: 8, display: 'flex', gap: 16 }}>
                        {['Devoir — Contrôle Continu', 'Devoir — Test', 'Examen — Examen Final'].map((label, i) => (
                          <div key={i} style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 2 }}>
                              <span style={{ color: 'var(--muted)' }}>{label}</span>
                              <span className="badge green" style={{ fontSize: 9 }}>Tout renseigné</span>
                            </div>
                            <div style={{ fontSize: 11, color: 'var(--success)' }}>{remplis}/{total}</div>
                          </div>
                        ))}
                      </div>

                      {/* Barre globale */}
                      <div style={{ marginTop: 8 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--muted)', marginBottom: 3 }}>
                          <span>Dossiers complets (devoir + examen)</span>
                          <span>{remplis}/{total} · {pct}%</span>
                        </div>
                        <div style={{ height: 5, background: 'var(--line)', borderRadius: 3 }}>
                          <div style={{ height: '100%', width: `${pct}%`, background: pct === 100 ? 'var(--success)' : 'var(--primary)', borderRadius: 3 }} />
                        </div>
                      </div>
                    </div>
                    <div style={{ marginLeft: 16, flexShrink: 0 }}>
                      <button className="btn btn-sm" onClick={() => navigate(`/evaluations/${ev.id}/saisie`)}>
                        Ouvrir la grille ›
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {filtered.length === 0 && <div className="card"><div className="empty">Aucune évaluation trouvée.</div></div>}
    </>
  );
}

function EdtEnseignant() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const today = new Date().toISOString().slice(0, 10);
  const todayLabel = new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  useEffect(() => {
    api.get('/timetable').then(setSessions).catch(() => {});
  }, []);

  const DAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

  return (
    <div className="card">
      <div className="card-head">
        <div>
          <h2>Mon Emploi du Temps</h2>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>Consultez votre planning hebdomadaire d'enseignements</div>
        </div>
        <button className="btn-ghost btn-sm">🖨 Imprimer</button>
      </div>
      <div className="card-body">
        {sessions.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--muted)' }}>
            <div style={{ fontSize: '2rem', marginBottom: 12 }}>📅</div>
            <div style={{ fontWeight: 500, marginBottom: 6 }}>Aucun cours planifié</div>
            <div style={{ fontSize: 12 }}>Vous n'avez aucun cours programmé pour ce semestre et cette année académique.</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr>
                  <th style={{ padding: '8px 12px', textAlign: 'center', background: 'var(--surface-soft)', borderBottom: '0.5px solid var(--line)', width: 100 }}>Horaire</th>
                  {DAYS.map((d) => <th key={d} style={{ padding: '8px 12px', textAlign: 'center', background: 'var(--surface-soft)', borderBottom: '0.5px solid var(--line)', borderLeft: '0.5px solid var(--line)' }}>{d}</th>)}
                </tr>
              </thead>
              <tbody>
                {sessions.slice(0, 3).map((s, i) => (
                  <tr key={i} style={{ borderBottom: '0.5px solid var(--line)' }}>
                    <td style={{ padding: '10px 12px', color: 'var(--muted)', textAlign: 'center' }}>
                      {s.startTime} – {s.endTime}
                    </td>
                    <td colSpan={6} style={{ padding: 6, borderLeft: '0.5px solid var(--line)' }}>
                      <div style={{ background: 'var(--primary-soft)', border: '0.5px solid var(--primary)', borderLeft: '3px solid var(--primary)', borderRadius: 6, padding: '8px 10px' }}>
                        <div style={{ fontWeight: 600, color: 'var(--primary)', fontSize: 12 }}>{s.subject?.name}</div>
                        <div style={{ fontSize: 11, color: 'var(--muted)' }}>{s.class?.name} · {s.room?.name || ''}</div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <button className="btn-ghost btn-sm" onClick={() => navigate('/emploi-du-temps')}>Voir l'emploi du temps complet →</button>
        </div>
      </div>
    </div>
  );
}

function PresencesEnseignant() {
  const navigate = useNavigate();
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState('');
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get('/catalog/classes').then((c) => { setClasses(c || []); if (c?.[0]) setClassId(c[0].id); }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!classId) return;
    api.get(`/attendance/roster?classId=${classId}&date=${new Date().toISOString().slice(0, 10)}`)
      .then((r) => setRows(r?.rows || r || [])).catch(() => {});
  }, [classId]);

  return (
    <div className="card">
      <div className="card-head">
        <h2>Gestion des Présences</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={classId} onChange={(e) => setClassId(e.target.value)} style={{ width: 160 }}>
            {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <button className="btn btn-sm" onClick={() => navigate('/presences')}>Ouvrir la feuille d'appel</button>
        </div>
      </div>
      <div className="card-body">
        {rows.length === 0 ? <div className="empty">Aucune donnée de présence. Faites l'appel depuis la feuille d'appel.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Élève</th><th>Matricule</th><th>Statut</th></tr></thead>
            <tbody>{rows.slice(0, 10).map((r) => (
              <tr key={r.studentId}>
                <td>{r.name}</td>
                <td className="mono">{r.matricule}</td>
                <td><span className={`badge ${r.status === 'PRESENT' ? 'green' : r.status === 'ABSENT' ? 'red' : 'gold'}`}>{r.status}</span></td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}

function CongesEnseignant({ staffId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!staffId) { setLoading(false); return; }
    api.get(`/staff/${staffId}/leave`)
      .then((d) => setData(d))
      .catch(() => setData({ balances: [], requests: [] }))
      .finally(() => setLoading(false));
  }, [staffId]);

  if (!staffId) return <div className="card"><div className="empty">Profil non trouvé.</div></div>;
  if (loading) return <div className="card"><div className="empty">Chargement…</div></div>;

  const { balances = [], requests = [] } = data || {};

  const STATUS = {
    PENDING:  { l: 'En attente',  cls: 'gold' },
    APPROVED: { l: 'Approuvée',   cls: 'green' },
    REJECTED: { l: 'Refusée',     cls: 'red' },
    CANCELLED:{ l: 'Annulée',     cls: 'gray' },
  };

  return (
    <>
      {/* Soldes */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-head"><h2>Soldes de congés — {new Date().getFullYear()}</h2></div>
        <div className="card-body">
          {balances.length === 0 ? (
            <div className="empty">Aucun solde de congé enregistré.</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
              {balances.map((b, i) => (
                <div key={i} style={{ border: '0.5px solid var(--line)', borderRadius: 8, padding: '14px 16px' }}>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>{b.leaveType}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ fontSize: '1.4rem', fontWeight: 700, color: 'var(--primary)' }}>{b.remaining}</span>
                    <span style={{ fontSize: 11, color: 'var(--muted)' }}>/ {b.entitled} jours</span>
                  </div>
                  <div style={{ marginTop: 8, height: 5, background: 'var(--line)', borderRadius: 3 }}>
                    <div style={{ height: '100%', borderRadius: 3, background: b.remaining > 0 ? 'var(--primary)' : 'var(--danger)', width: `${b.entitled > 0 ? Math.round(b.remaining / b.entitled * 100) : 0}%` }} />
                  </div>
                  <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 4 }}>
                    Pris : {b.taken}j &nbsp;·&nbsp; En attente : {b.pending}j
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Demandes */}
      <div className="card">
        <div className="card-head"><h2>Mes demandes de congé</h2></div>
        <div className="card-body" style={{ padding: 0 }}>
          {requests.length === 0 ? (
            <div className="empty" style={{ padding: 24 }}>Aucune demande de congé.</div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Du</th>
                    <th>Au</th>
                    <th className="num">Jours</th>
                    <th>Statut</th>
                    <th>Motif</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((r) => {
                    const { l, cls } = STATUS[r.status] || { l: r.status, cls: 'gray' };
                    return (
                      <tr key={r.id}>
                        <td>{r.leaveType}</td>
                        <td>{new Date(r.startDate).toLocaleDateString('fr-FR')}</td>
                        <td>{new Date(r.endDate).toLocaleDateString('fr-FR')}</td>
                        <td className="num">{r.durationDays}</td>
                        <td><span className={`badge ${cls}`}>{l}</span></td>
                        <td style={{ color: 'var(--muted)', fontSize: 12 }}>{r.reason || '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
